export default __webpack_public_path__ + "static/media/LEGA9200.35bcd8af.jpg";